module.exports = AFRAME.registerComponent('checkpoint', {
  schema: {
    offset: {
      default: {
        x: 0,
        y: 0,
        z: 0
      },
      type: 'vec3'
    }
  },
  init: function init() {
    this.active = false;
    this.targetEl = null;
    this.fire = this.fire.bind(this);
    this.offset = new THREE.Vector3();
  },
  update: function update() {
    this.offset.copy(this.data.offset);
  },
  play: function play() {
    this.el.addEventListener('click', this.fire);
  },
  pause: function pause() {
    this.el.removeEventListener('click', this.fire);
  },
  remove: function remove() {
    this.pause();
  },
  fire: function fire() {
    var targetEl = this.el.sceneEl.querySelector('[checkpoint-controls]');
    if (!targetEl) {
      throw new Error('No `checkpoint-controls` component found.');
    }
    targetEl.components['checkpoint-controls'].setCheckpoint(this.el);
  },
  getOffset: function getOffset() {
    return this.offset.copy(this.data.offset);
  }
});